import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, ViewChild} from '@angular/core';
import { AuthenticationService } from './services/security';
import * as moment from 'moment';
import { DisplayService } from './services';
import { debounce } from '@shared/decorator/debounce.decorator';
import { Location } from "@angular/common";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked{
  title = 'Décisiel - Logiciel de gouvernance';
  headerVisible = false;
  goToTopButtonVisible: boolean;
  remainingTime: number;
  display: boolean = false;
  timeout: number;
  deconnect: boolean;
  interval: any;
  IsloginPage: boolean;
  IslikeloginPage: boolean;

  constructor(private displayService: DisplayService, private authService: AuthenticationService, private location: Location, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.displayService.emitChangeResolution(window.innerWidth);
    moment.locale('fr'); 
    this.headerVisible = this.authService.IsAuthenticated();
    this.authService.authenticationState.subscribe(() => {
      this.headerVisible = this.authService.IsAuthenticated();
      if (this.headerVisible == null) this.headerVisible = false;
    })
    this.IslikeloginPage = this.checkIslikelogin();
    this.authService.isLoginPage.subscribe((response) => {
      this.IsloginPage = response;
      this.headerVisible
    });
    this.authService.sessionExpired.subscribe(
      (res: boolean ) => {

        if (res == true) {         
          this.deconnect = true;       
          this.remainingTime = 59;
          this.timeout = this.authService.sTimeout;
          this.interval = setInterval(() => {

              this.decount();
          }, 1000);

          this.display = true;
        } 
      }
    );
  }

  decount() {
    this.remainingTime--;
    if (this.remainingTime == 0 && this.deconnect) {        
        this.disconnect();
    }
 }

 disconnect()
 {
     this.deconnect = false;
     clearInterval(this.interval);
     this.authService.logout();
     this.display = false;
 }

 continue()
 {
     this.deconnect = false;
     clearInterval(this.interval);
     this.authService.setSessionTimeout();
     this.display = false;
 }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.goToTopButtonVisible = window.pageYOffset > 100;
  }

  @HostListener('window:resize', ['$event'])
  @debounce()
  onResize(event) {
    this.displayService.emitChangeResolution(window.innerWidth);
  }

  goToTopPage(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  checkIslikelogin(): boolean {
    let searchPatterns = [
      "ResetPassword",
      "confirmEmail",
      "/lostPassword",
      "send-code",
      "verify-code"
    ];
    return searchPatterns.some(
      (v: string) => this.location.path().indexOf(v) >= 0
    );
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}
